import React, { Component } from 'react';
import DatePickerAgro from './DatePickerAgro.jsx';
import VigenciaAlta from './VigenciaAlta.jsx';
import VigenciaRenovacion from './VigenciaRenovacion.jsx';

class InputDates extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        let inputAgroDate = null;

        if (this.props.data != undefined && this.props.data != "") {
            if (this.props.data.EnterpriseType == "Agro") {
                inputAgroDate = <div>
                    <div className="col-xs-12">
                        <div>
                            <DatePickerAgro
                                data={this.props.data}
                                changeDate={this.props.changeDate} />
                        </div>
                    </div>
                </div>
            }
        }

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div className="row">
                        <VigenciaAlta
                            tarjetas={this.props.tarjetas}
                            data={this.props.data}
                            changeInput={this.props.changeInput}
                            form={this.props.form} />
                        <VigenciaRenovacion
                            tarjetas={this.props.tarjetas}
                            data={this.props.data}
                            changeInput={this.props.changeInput}
                            form={this.props.form} />
                    </div>
                    <div className="row">
                        {inputAgroDate}
                    </div>
                </div>
            </div>
        );
    }
};

export default InputDates;